"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPlayer = exports.doInvitePlayer = exports.invitePlayer = exports.setPlayerAsReadyForNext = exports.setPlayerAsDone = exports.setPlayerAsFailed = exports.setPlayerAsPassed = exports.setPlayerAsRunning = exports.setPlayerAsDefault = exports.nextTask = exports.skipTask = exports.submitCode = exports.runCode = exports.signupAndSave = exports.saveCode = exports.setAvatar = exports.grabAvatar = exports.loadCode = exports.loadContent = exports.saveContent = exports.receiveSubmitCodeResult = exports.receiveRunCodeResult = exports.setElapsed = exports.stopCounting = exports.startCounting = exports.gameComplete = exports.gameStart = exports.disconnectPlayer = exports.connectPlayer = exports.removePlayer = exports.doAddPlayer = exports.setPlayerEditorIndex = exports.resetStatusesToDefault = exports.setAllSkeletonCode = exports.setSkeletonCode = exports.doSkipTask = exports.runCodeRequest = exports.setCode = exports.remoteRequestNextTask = exports.remoteRequestSkipTask = exports.remoteRequestSubmitCode = exports.remoteRequestRunCode = exports.buttonTypeClicked = exports.codeChanged = exports.setupChallenge = exports.setState = exports.setRoomId = exports.joinGame = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _css = require("css");

var _css2 = _interopRequireDefault(_css);

var _normalizr = require("normalizr");

var _runner = require("../libs/server/runner");

var _runner2 = _interopRequireDefault(_runner);

var _requests = require("../libs/utils/requests");

var _meta = require("./meta");

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

var _GameActionTypes = require("../constants/action-types/GameActionTypes");

var types = _interopRequireWildcard(_GameActionTypes);

var _ChallengeData = require("../constants/ChallengeData");

var challengeData = _interopRequireWildcard(_ChallengeData);

var _ChallengeEvents = require("../constants/ChallengeEvents");

var challengeEvents = _interopRequireWildcard(_ChallengeEvents);

var _CodeLanguages = require("../constants/CodeLanguages");

var codeLanguages = _interopRequireWildcard(_CodeLanguages);

var _PlayerStatuses = require("../constants/PlayerStatuses");

var playerStatuses = _interopRequireWildcard(_PlayerStatuses);

var _ui = require("./ui");

var UIActions = _interopRequireWildcard(_ui);

var _modals = require("./modals");

var ModalsActions = _interopRequireWildcard(_modals);

var _ModalTypes = require("../constants/ModalTypes");

var ModalTypes = _interopRequireWildcard(_ModalTypes);

var _game = require("../selectors/game");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}
/**
 * This module contains all of the actions that exist within our Redux
 * ecosystem. Actions from here are dispatched to the stores in order
 * to update the state.
 * Right now this module includes all the different action types,
 * including those reduced on client-only, server-only or on both.
 *
 * Actions are tagged with meta information which is quite important
 * for understanding the flow of actions throughout the system. These
 * tags are interpreted in middleware and help inform the routing
 * of actions throughout the system. Here is a current list and
 * explanations of the meta types.
 *
 * shared: true|false
 *  Shared actions are intended to be dispatched from client-side
 *  interactions. The shared tag indicates that these actions are
 *  to be shared across that client's peers (i.e. other players in
 *  the game).
 *
 *  Shared actions are interpreted by the remote-action middleware on
 *  the client-side store and tagged up with the sender's playerId
 *  before being sent to the server via socket-io. This local client
 *  also immediately reduces that action. The server reduces
 *  this action on the server redux store before broadcasting the same
 *  action back to all other players in the room. Once it reaches the
 *  other players/clients, the action is reduced on their local stores.
 *
 *  This flow ensures that the server store is kept informed of any
 *  local state changes, and that actions are replayed (shared) across
 *  all players in the game
 *
 *  An example is when a player types code in their code editor. This
 *  code change is a shared action.
 *
 *  - reduced on local client
 *  - reduced on server
 *  - reduced on all other clients
 *
 * remoteRequest: true|false
 *   RemoteRequest actions are intended to be dispatched from clients
 *   to request action of the server.
 *
 *   Actions are dispatched from the client and interpreted by the
 *   remote-action middleware
 *
 *   - not reduced anywhere
 *   - trigger server-side dispatch, which may be an async action (thus
 *     trigger further actions which relay back to the clients)
 *
 * serverShared: true|false
 *  this is used when an action reduces on the server, and wants to be bounced to other clients. shared is reducing
 * actions locally on both clients
 *
 * skipPersist: true|false
 *
 */


var dockerUrl = "http://docker.worldofcode.co.uk:24900/runCode"; //TODO: Split these in to sub-files

var joiningFailure = function joiningFailure(_ref) {
  var message = _ref.message;
  return {
    type: types.JOINING_FAILURE,
    payload: {
      message: message
    }
  };
}; // onPlayerJoinRoom comes from HOC for sockets atm


var joinGame = exports.joinGame = function joinGame(_ref2) {
  var gameId = _ref2.gameId,
      onPlayerJoinRoom = _ref2.onPlayerJoinRoom;
  return function (dispatch) {
    var destination = _config2.default.serviceUrls.api.rooms + "/" + gameId + "/status/join";
    var fetchOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };
    return (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions
    }).then(function () {
      dispatch(setRoomId(gameId));
      onPlayerJoinRoom(gameId);
    }).catch(function (err) {
      return dispatch(joiningFailure(err));
    });
  };
}; //===============
// game actions
//===============


var setRoomId = exports.setRoomId = function setRoomId(id) {
  return {
    type: types.SET_ROOM_ID,
    payload: {
      id: id
    }
  };
};

var setState = exports.setState = function setState(state) {
  return {
    type: types.SET_GAME_STATE,
    payload: {
      state: state
    }
  };
};

var normaliseChallenge = function normaliseChallenge(_ref3) {
  var roomId = _ref3.roomId,
      challenge = _ref3.challenge,
      numPlayers = _ref3.numPlayers;
  var task = new _normalizr.schema.Entity("tasks", {}, {
    // idAttribute: '_id',
    //TODO: Generating IDs because this is how the front-end looks up now
    // (based on currentTaskNumber in tasks map). But could do something like this to state tree..
    // tasks: ["570e989baeed2db00aada1bf", "570e989baeed2db00aada1c1"]
    // tasksById: {570e989baeed2db00aada1bf -> task, 570e989baeed2db00aada1c1 -> task}
    // then we can do currentTask lookup like taskId = tasks[currentTaskNumber]
    // task = tasksById[taskId]
    idAttribute: function idAttribute(entity, parent, key) {
      var index = -1;
      parent.forEach(function (e, i) {
        if (e._id === entity._id) {
          index = i;
        }
      });
      return index;
    },
    processStrategy: function processStrategy(entity, parent, key) {
      switch (key) {
        //root entity = null
        // es6 way, but little support Array(numPlayers).fill({...entity.playerInfo})
        case null:
          var array = [].concat(_toConsumableArray(entity.playerInfo)); // create a new array with AT LEAST the desired number of elements by joining the array at the end of the new array

          while (array.length <= numPlayers) {
            array = [].concat(_toConsumableArray(array), _toConsumableArray(array));
          } // reduce the new array to the desired length (as there might be too many elements in the new array


          array = array.slice(0, numPlayers);
          return _extends({}, entity, {
            playerInfo: array
          });
      }

      return _extends({}, entity);
    }
  });
  var playerInfo = new _normalizr.schema.Entity("playerInfoById", {}, {
    idAttribute: "_id"
  }); //define relationship between task/playerInfo

  task.define({
    playerInfo: [playerInfo]
  }); //^End of define normalizer

  var normalized = (0, _normalizr.normalize)(challenge.tasks, [task]);
  var eventsMap = {
    eventsMap: challenge.eventsMap
  };
  return {
    roomId: roomId,
    entities: _extends({}, normalized.entities, eventsMap)
  };
};

var setupChallenge = exports.setupChallenge = function setupChallenge(info) {
  return {
    type: types.SETUP_CHALLENGE,
    payload: _extends({}, normaliseChallenge(info)),
    meta: {
      shared: true
    }
  };
}; //User Actions


var codeChanged = exports.codeChanged = function codeChanged(playerId, code, codeIndex) {
  return {
    type: types.CODE_CHANGED,
    payload: {
      playerId: playerId,
      code: code,
      codeIndex: codeIndex
    },
    meta: {
      shared: true
    }
  };
};

var buttonTypeClicked = exports.buttonTypeClicked = function buttonTypeClicked(buttonType) {
  return {
    type: types.BUTTON_TYPE_CLICKED,
    payload: {
      buttonType: buttonType
    }
  };
}; //+Remote Requests+


var remoteRequestRunCode = exports.remoteRequestRunCode = function remoteRequestRunCode() {
  return {
    type: types.REMOTE_REQUEST_RUN_CODE,
    meta: {
      remoteRequest: true //experimental for remoteActionMap
      // payload: {
      //   actionType: types.RUN_CODE
      // }

    }
  };
};

var remoteRequestSubmitCode = exports.remoteRequestSubmitCode = function remoteRequestSubmitCode() {
  return {
    type: types.REMOTE_REQUEST_SUBMIT_CODE,
    meta: {
      remoteRequest: true // payload: {
      //   actionType: types.SUBMIT_CODE
      // }

    }
  };
};

var remoteRequestSkipTask = exports.remoteRequestSkipTask = function remoteRequestSkipTask() {
  return {
    type: types.REMOTE_REQUEST_SKIP_TASK,
    meta: {
      remoteRequest: true
    }
  };
};

var remoteRequestNextTask = exports.remoteRequestNextTask = function remoteRequestNextTask() {
  return {
    type: types.REMOTE_REQUEST_NEXT_TASK,
    meta: {
      remoteRequest: true
    }
  };
};

var setCode = exports.setCode = function setCode(code, playerId) {
  return {
    type: types.SET_CODE,
    payload: {
      code: code,
      playerId: playerId
    },
    meta: {
      shared: true
    }
  };
};

var runCodeRequest = exports.runCodeRequest = function runCodeRequest(playerId) {
  return {
    type: types.RUN_CODE_REQUEST,
    payload: {
      playerId: playerId
    },
    meta: {
      serverShared: true
    }
  };
};

var doSkipTask = exports.doSkipTask = function doSkipTask() {
  return {
    type: types.DO_SKIP_TASK,
    meta: {
      serverShared: true
    }
  };
};

var setSkeletonCode = exports.setSkeletonCode = function setSkeletonCode(playerId) {
  return {
    type: types.SET_SKELETON_CODE,
    payload: {
      playerId: playerId
    },
    meta: {
      shared: true
    }
  };
};

var setAllSkeletonCode = exports.setAllSkeletonCode = function setAllSkeletonCode() {
  return {
    type: types.SET_ALL_SKELETON_CODE,
    meta: {
      shared: true
    }
  };
};

var resetStatusesToDefault = exports.resetStatusesToDefault = function resetStatusesToDefault() {
  return {
    type: types.RESET_STATUSES_TO_DEFAULT,
    meta: {
      serverShared: true
    }
  };
};

var setPlayerState = function setPlayerState(playerId, playerState) {
  return {
    type: types.SET_PLAYER_STATE,
    payload: {
      playerId: playerId,
      playerState: playerState
    },
    meta: {
      serverShared: true
    }
  };
};

var setPlayerEditorIndex = exports.setPlayerEditorIndex = function setPlayerEditorIndex(playerId, editorIndex) {
  return {
    type: types.SET_PLAYER_EDITOR_INDEX,
    payload: {
      playerId: playerId,
      editorIndex: editorIndex
    },
    meta: {
      serverShared: true
    }
  };
}; //TODO: In reality, this could be done as just a shared thing really..?


var doAddPlayer = exports.doAddPlayer = function doAddPlayer(index, playerName) {
  return {
    type: types.ADD_PLAYER,
    payload: {
      index: index,
      playerName: playerName
    },
    meta: {
      shared: true
    }
  };
}; //removing player


var removePlayer = exports.removePlayer = function removePlayer(playerId) {
  return {
    type: types.REMOVE_PLAYER,
    meta: {
      shared: true
    },
    payload: {
      playerId: playerId
    }
  };
}; //all this does is simply to set the user at that index to isConnected = true


var connectPlayer = exports.connectPlayer = function connectPlayer(playerId) {
  return {
    type: types.CONNECT_PLAYER,
    meta: {
      serverShared: true
    },
    payload: {
      playerId: playerId
    }
  };
};

var disconnectPlayer = exports.disconnectPlayer = function disconnectPlayer(playerId) {
  return {
    type: types.DISCONNECT_PLAYER,
    meta: {
      serverShared: true
    },
    payload: {
      playerId: playerId
    }
  };
}; //Right now these don't affect the state in any way, just get stored in the DB.


var gameStart = exports.gameStart = function gameStart() {
  return {
    type: types.GAME_START
  };
};

var gameComplete = exports.gameComplete = function gameComplete() {
  return {
    type: types.GAME_COMPLETE
  };
};

var startCounting = exports.startCounting = function startCounting() {
  return {
    type: types.START_COUNTING
  };
};

var stopCounting = exports.stopCounting = function stopCounting() {
  return {
    type: types.STOP_COUNTING
  };
}; //Server Actions


var setElapsed = exports.setElapsed = function setElapsed(elapsed) {
  return {
    type: types.SET_ELAPSED,
    payload: {
      elapsed: elapsed
    }
  };
}; //TODO: Review in comparison to receiveSubmitCodeResult() function.


var receiveRunCodeResult = exports.receiveRunCodeResult = function receiveRunCodeResult(playerId, result, valid) {
  //TODO: Make this based on test result rather than presence of stderr
  if (typeof valid === "undefined") {
    valid = !result.stderr;
  } //TODO: Temp measure to bring sandbox output in line. Need to agree on running result format overall really..


  if (result && result.err) {
    result.stderr = result.err;
  }

  if (result && result.consoleOutput) {
    result.stdout = result.consoleOutput;
  }

  return {
    type: types.RECEIVE_RUN_CODE_RESULT,
    //TODO: Reshape this payload. codeResult is runOutput really (well for current json anyway)
    payload: {
      codeResult: result,
      valid: valid,
      playerId: playerId
    },
    meta: {
      serverShared: true
    }
  };
};

var receiveSubmitCodeResult = exports.receiveSubmitCodeResult = function receiveSubmitCodeResult(playerId, result, valid) {
  //TODO: Make this based on test result rather than presence of stderr
  if (typeof valid === "undefined") {
    valid = !result.stderr;
  } //TODO: Temp measure to bring sandbox output in line. Need to agree on running result format overall really..


  if (result && result.err) {
    result.stderr = result.err;
  }

  if (result && result.consoleOutput) {
    result.stdout = result.consoleOutput;
  }

  return {
    type: types.RECEIVE_SUBMIT_CODE_RESULT,
    //TODO: Reshape this payload. codeResult is runOutput really (well for current json anyway)
    payload: {
      codeResult: result,
      valid: valid,
      playerId: playerId
    },
    meta: {
      serverShared: true
    }
  };
}; //TODO: !IMPORTANT
//TODO: bug in this somewhere when loading a saved file, it doesn't updated the run code request sent (uses the old code for some reason)
//TODO: if this stays as just a single dispatch, can bypass


var saveContent = exports.saveContent = function saveContent(playerId, name, challenge) {
  return function (dispatch, getState) {
    //TODO: flow should be: save character -> success, show success, hide dialog -> failure, error message/try again, hide dialog?
    dispatch(saveCode({
      context: name,
      challenge: challenge
    })); //TODO: handled outside in new ModalRoot flow
    // dispatch(hideSaveDialog());
  };
}; //TODO: if this stays as just a single dispatch, can bypass


var loadContent = exports.loadContent = function loadContent(playerId, name, challenge) {
  return function (dispatch, getState) {
    dispatch(loadCode(playerId, {
      context: name,
      challenge: challenge
    })); //TODO: handled outside in new ModalRoot flow
    // dispatch(hideLoadDialog());
  };
};

var loadCode = exports.loadCode = function loadCode(playerId, _ref4) {
  var context = _ref4.context,
      challenge = _ref4.challenge;
  return function (dispatch, getState, _ref5) {
    var uploadContent = _ref5.uploadContent;
    var state = getState();
    var destination = uploadContent.loadContentUrl;
    var fetchOptions = {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    }; //TODO: removed hard-coded challenge name and now injected, but not the smoothest method

    var query = {
      // TODO: These types are never actually read on the server-side so commenting out for now
      // types: selectors.getThisPlayerCurrentLanguages(state)
      types: []
    }; //TODO: still also catering for the old legacy S3 setup! Change asap

    destination += "/" + (0, _game.selectThisPlayerName)(state) + "/" + challenge + "/" + context;
    return (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions,
      query: query
    }).then(function (response) {
      return dispatch(setCode(response, playerId));
    }).catch(function (error) {
      return console.error(error);
    });
  };
};

var grabAvatar = exports.grabAvatar = function grabAvatar() {
  return function (dispatch) {
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.avatar
    }).then(function (_ref6) {
      var avatar = _ref6.payload.avatar;
      return dispatch((0, _meta.storeAvatarUrl)({
        url: avatar
      }));
    });
  };
};

var setAvatar = exports.setAvatar = function setAvatar(_ref7) {
  var name = _ref7.name,
      url = _ref7.url;
  return function (dispatch) {
    var fetchOptions = {
      method: "POST",
      body: JSON.stringify({
        name: name,
        url: url
      })
    };
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.avatar,
      options: fetchOptions
    }).then(function () {
      return dispatch((0, _meta.storeAvatarUrl)({
        url: url
      }));
    }).catch(function (err) {
      return console.log(err);
    });
  };
};

var saveCode = exports.saveCode = function saveCode(_ref8) {
  var context = _ref8.context,
      challenge = _ref8.challenge;
  return function (dispatch, getState, _ref9) {
    var uploadContent = _ref9.uploadContent;
    var state = getState(); // const challenge = selectChallengeName(getState());

    var destination = uploadContent.saveContentUrl;
    var options = {};
    options.challenge = challenge;
    var user = (0, _game.selectThisPlayerName)(state);
    options.user = user;
    options.content = (0, _game.selectThisPlayerContent)(state);

    switch (challenge) {
      // TODO: case: character, choose character dialogue box
      case challengeData.CHARACTER_BUILDING_CHALLENGE:
        // TODO: dialogue and memoised selector should populate fileName
        //TODO: Do we need this? can we just rely on the url (dev or prod)
        options.contextName = context || (0, _game.selectThisPlayerCharacterName)(state);
        var url = encodeURI(_config2.default.aws.s3.url + "/" + _config2.default.aws.s3.contentBucket + "/users/" + user + "/" + challengeData.CHARACTER_BUILDING_CHALLENGE + "/" + context + "/" + context + ".svg");
        break;
      // TODO: default: choose file dialogue box

      default:
        //TODO: obvs not default behaviour yet
        options.contextName = context || "default";
    } // notification info


    var info = {
      success: {
        title: "Saving Successful",
        message: "You have successfully saved :)"
      },
      error: {
        title: "Failed to save :("
      },
      waiting: {
        title: "Saving",
        message: "We are saving now..."
      }
    };

    if (!destination) {
      return Promise.reject("Oops. Couldn't find where to save to :(");
    }

    return Promise.resolve(sendSaveCode({
      destination: destination,
      info: info,
      options: options
    }, dispatch));
  };
};

var sendSaveCode = function sendSaveCode(_ref10, dispatch) {
  var destination = _ref10.destination,
      options = _ref10.options; //disable save and notify user

  dispatch(UIActions.disableSaveButton());
  var fetchOptions = {
    method: "POST",
    body: JSON.stringify(options),
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    }
  };
  return (0, _requests.sendRequest)({
    destination: destination,
    options: fetchOptions
  }).then(function () {
    dispatch(UIActions.enableSaveButton());
    dispatch(ModalsActions.showModal({
      modalType: ModalTypes.GO_PLAY,
      meta: {
        premium: true
      }
    }));
  }).catch(function () {
    return dispatch(UIActions.enableSaveButton());
  });
};

var signupAndSave = exports.signupAndSave = function signupAndSave(registerInfo) {
  return function (dispatch, getState, _ref11) {
    var api = _ref11.api; //TODO: handled outside now
    // dispatch(hideSignup());

    var destination = api.users;
    var fetchOptions = {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(registerInfo),
      headers: {
        "Content-Type": "application/json"
      }
    };
    return (0, _requests.sendRequest)({
      destination: destination,
      options: fetchOptions
    }).then(function (response) {
      var user = response.payload.user; //setPlayerName based on payload

      dispatch(doAddPlayer(0, user.username));
      dispatch(saveCode({}));
    });
  };
}; //+Server Async Actions+
//Running code


var runCode = exports.runCode = function runCode(playerId) {
  return function (dispatch, getState) {
    //TODO: Should be returning promises
    dispatch(runCodeRequest(playerId));

    var _getRunCodeInfo = getRunCodeInfo(getState(), playerId),
        code = _getRunCodeInfo.code,
        language = _getRunCodeInfo.language,
        test = _getRunCodeInfo.test,
        required = _getRunCodeInfo.required;

    if (language === codeLanguages.CSS.type) {
      var codeSuccess = testCssCode(test, code);
      dispatch(receiveRunCodeResult(playerId, null, codeSuccess));
      return Promise.resolve();
    }

    if (codeLanguages.isDockerRunningLanguage(language)) {
      if (language === codeLanguages.JS.type) {
        //Rename JS to 'node' to match docker-runner API
        // language = 'node';
        var runnerOptions = {
          code: code,
          testCode: test
        };

        if (required) {
          runnerOptions.required = required;
        }

        return (0, _runner2.default)(runnerOptions, function (result) {
          return dispatch(receiveRunCodeResult(playerId, result, result.valid));
        });
      }

      var fetchOptions = {
        method: "POST",
        body: JSON.stringify({
          language: language,
          code: code
        }),
        headers: {
          "Content-Type": "application/json"
        }
      };
      return (0, _requests.sendRequest)({
        destination: dockerUrl,
        options: fetchOptions
      }).then(function (response) {
        return dispatch(receiveRunCodeResult(playerId, response));
      });
    } //default case: no test


    return dispatch(receiveSubmitCodeResult(playerId, null, true));
  };
}; //Submitting code


var submitCode = exports.submitCode = function submitCode(playerId) {
  return function (dispatch, getState) {
    //TODO: Leveraging runCode actions here. Probably want a separate for submitCode at some point..
    //TODO: Should be returning promises
    dispatch(runCodeRequest(playerId));

    var _getRunCodeInfo2 = getRunCodeInfo(getState(), playerId),
        code = _getRunCodeInfo2.code,
        language = _getRunCodeInfo2.language,
        test = _getRunCodeInfo2.test,
        required = _getRunCodeInfo2.required;

    if (language === codeLanguages.CSS.type) {
      var codeSuccess = testCssCode(test, code);
      return dispatch(receiveSubmitCodeResult(playerId, null, codeSuccess));
    }

    if (codeLanguages.isDockerRunningLanguage(language)) {
      if (language === codeLanguages.JS.type) {
        //Rename JS to 'node' to match docker-runner API
        // language = 'node';
        var runnerOptions = {
          code: code,
          testCode: test
        };

        if (required) {
          runnerOptions.required = required;
        }

        return (0, _runner2.default)(runnerOptions, function (result) {
          return dispatch(receiveSubmitCodeResult(playerId, result, result.valid));
        });
      } //else is docker running code


      var fetchOptions = {
        method: "POST",
        body: JSON.stringify({
          language: language,
          code: code
        }),
        headers: {
          "Content-Type": "application/json"
        }
      };
      return (0, _requests.sendRequest)({
        destination: dockerUrl,
        options: fetchOptions
      }).then(function (response) {
        return dispatch(receiveSubmitCodeResult(playerId, response));
      });
    } //default case: no test


    return dispatch(receiveSubmitCodeResult(playerId, null, true));
  };
}; //Skipping task


var skipTask = exports.skipTask = function skipTask() {
  return function (dispatch, getState) {
    //TODO: probably a request action too - disable buttons and stuff whilst processing..
    if ((0, _game.selectIsFinalTask)(getState())) {
      return;
    } //TODO: rename doSkipTask (really, increment currentTaskNumber)


    dispatch(doSkipTask());
    dispatch(setAllSkeletonCode());
    dispatch(resetStatusesToDefault());
    var challengeEvent = (0, _game.selectCurrentEvent)(getState());

    if (challengeEvent) {
      dispatch(challengeEvents.mapEventToAction(challengeEvent));
    } //tell players of the new task/state
    // dispatch(receiveSkipTaskResult(getState().game));

  };
}; //Old thinking way of doing it. Old flow was, do all skip task operations on server (incrementTaskNumber, setSkeletonCode, resetStatuses) then, send the updated state to the clients. But, can just make all of those actions shared really..

/*export const receiveSkipTaskResult = (state) => {
 return {
 type: types.RECEIVE_SKIP_TASK_RESULT,
 meta: {
 serverShared: true
 },
 payload: {
 state: state
 }
 }
 };*/
//Moving to next


var nextTask = exports.nextTask = function nextTask(playerId) {
  return function (dispatch, getState) {
    dispatch(setPlayerAsReadyForNext(playerId));

    if ((0, _game.selectCombinedPlayerStatus)(getState()) === playerStatuses.READY_FOR_NEXT) {
      dispatch(skipTask());
    }
  };
};

var setPlayerAsDefault = exports.setPlayerAsDefault = function setPlayerAsDefault(playerId) {
  return setPlayerState(playerId, playerStatuses.DEFAULT);
};

var setPlayerAsRunning = exports.setPlayerAsRunning = function setPlayerAsRunning(playerId) {
  return setPlayerState(playerId, playerStatuses.RUNNING);
};

var setPlayerAsPassed = exports.setPlayerAsPassed = function setPlayerAsPassed(playerId) {
  return setPlayerState(playerId, playerStatuses.PASSED);
};

var setPlayerAsFailed = exports.setPlayerAsFailed = function setPlayerAsFailed(playerId) {
  return setPlayerState(playerId, playerStatuses.FAILED);
};

var setPlayerAsDone = exports.setPlayerAsDone = function setPlayerAsDone(playerId) {
  return setPlayerState(playerId, playerStatuses.DONE);
};

var setPlayerAsReadyForNext = exports.setPlayerAsReadyForNext = function setPlayerAsReadyForNext(playerId) {
  return setPlayerState(playerId, playerStatuses.READY_FOR_NEXT);
}; // export const addPlayers = (playerNames) => {
//   return (dispatch) => {
//     playerNames.forEach(playerName => dispatch(addPlayer({playerName})));
//   }
// }
//Adding a player


var invitePlayer = exports.invitePlayer = function invitePlayer(_ref12) {
  var playerName = _ref12.playerName,
      roomId = _ref12.roomId;
  return function (dispatch, getState) {
    var state = getState(); // TODO: Check these selectors with params work

    if ((0, _game.selectIsPlayerInRoom)(state, playerName)) {
      console.log(playerName + " in room already"); //TODO: dispatch new action to give user info that player has already been invited/already in room

      return;
    }

    if ((0, _game.selectIsInvited)(state, playerName)) {
      console.log(playerName + " invited in room already");
      return;
    }

    var nextFreePlayerSlot = (0, _game.selectNextFreePlayerSlot)(state);

    if (nextFreePlayerSlot < 0) {
      console.log("room is too full to invite " + playerName);
      return;
    } //TODO: ERROR in this - think about the flow!
    //TODO: add check for trying to add duplicate name
    //TODO: Need to think about player rejoining


    dispatch(doInvitePlayer(playerName));
  };
};

var doInvitePlayer = exports.doInvitePlayer = function doInvitePlayer(playerName) {
  return {
    type: types.INVITE_PLAYER,
    payload: {
      playerName: playerName
    },
    meta: {
      shared: true
    }
  };
}; //Adding a player


var addPlayer = exports.addPlayer = function addPlayer(_ref13) {
  var playerName = _ref13.playerName,
      index = _ref13.index,
      challenge = _ref13.challenge,
      roomId = _ref13.roomId;
  return function (dispatch, getState) {
    var state = getState();

    if ((0, _game.selectIsPlayerInRoom)(state, playerName)) {
      //TODO: dispatch new action to give user info that player has already been invited/already in room
      return;
    }

    var nextFreePlayerSlot = index;

    if (index === undefined) {
      nextFreePlayerSlot = (0, _game.selectNextFreePlayerSlot)(state);
    }

    if (nextFreePlayerSlot < 0) {
      return;
    } //TODO: ERROR in this - think about the flow!
    //TODO: add check for trying to add duplicate name
    //TODO: Need to think about player rejoining


    dispatch(doAddPlayer(nextFreePlayerSlot, playerName));

    if (typeof challenge === "undefined") {
      console.error("NO CHALLENGE DEFINED");
      return;
    }

    var numPlayers = (0, _game.selectRoomSize)(state);
    dispatch(setupChallenge({
      roomId: roomId,
      challenge: challenge,
      numPlayers: numPlayers
    }));
  };
}; //+Non-action functions+


var testCssCode = function testCssCode(testCode, actualCode) {
  if (!testCode) {
    return true;
  }

  if (!actualCode) {
    return false;
  }

  var testCssTree = void 0;
  var codeCssTree = void 0;
  var parseError = false;

  try {
    testCssTree = _css2.default.parse(testCode);
  } catch (e) {
    //TODO: How should we handle this? Let players progress if task-creator has
    // made a mistake..?
    console.error("Failed to parse css test code, check test definition");
    console.error(testCode);
    console.error(e);
    parseError = true;
  }

  try {
    codeCssTree = _css2.default.parse(actualCode);
  } catch (e) {
    //TODO: Return informative error to player
    console.log("Failed to parse player css code");
    parseError = true;
  }

  if (parseError) {
    return false;
  }

  var testCssRules = testCssTree.stylesheet.rules;
  var codeCssRules = codeCssTree.stylesheet.rules;
  var passedTests = 0;

  for (var i = 0; i < testCssRules.length; i++) {
    for (var j = 0; j < codeCssRules.length; j++) {
      if (!testCssRules[i].selectors[0] || !codeCssRules[j].selectors[0] || !testCssRules[i].declarations[0] || !codeCssRules[j].declarations[0]) {
        return false;
      }

      if (testCssRules[i].selectors[0] === codeCssRules[j].selectors[0]) {
        if (testCssRules[i].declarations[0].property === codeCssRules[j].declarations[0].property && testCssRules[i].declarations[0].value === codeCssRules[j].declarations[0].value) {
          passedTests++;
        }
      }
    }
  }

  return passedTests >= testCssRules.length;
};

var getRunCodeInfo = function getRunCodeInfo(state, playerId) {
  var _selectPlayerStateFro = (0, _game.selectPlayerStateFromPlayerId)(state, playerId),
      code = _selectPlayerStateFro.code;

  var _selectPlayerInfoFrom = (0, _game.selectPlayerInfoFromPlayerId)(state, playerId),
      languages = _selectPlayerInfoFrom.languages,
      tests = _selectPlayerInfoFrom.tests,
      required = _selectPlayerInfoFrom.required;

  return {
    code: code,
    language: languages[0],
    test: tests[0],
    required: required
  };
};